var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || ($(window).width() < 992) ? true : false;
var arrowShape = { x0: 30, x1: 60, y1: 35, x2: 65, y2: 30, x3: 40 };

$(function() {

  helpers();
  initHeader();
  initFilters();

  if (!isMobile) {

    $('[data-toggle="tooltip"]').tooltip({
      html: true,
      placement: 'auto right',
      viewport: {
        selector: 'body',
        padding: 10
      }
    });


    stickyFilters();

  }

  $('.more').click(function(e) {
    e.preventDefault();
  });
  
});
